import { render } from "./Tabs.vue?vue&type=template&id=2531f3d3&scoped=true"
import script from "./Tabs.vue?vue&type=script&lang=js"
export * from "./Tabs.vue?vue&type=script&lang=js"

import "./Tabs.vue?vue&type=style&index=0&id=2531f3d3&scoped=true&lang=css"

import exportComponent from "C:\\Entwicklung\\werbeo-app-private\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2531f3d3"]])

export default __exports__